import { clsx } from "clsx";
import { cloneElement, forwardRef, useState } from "react";

type InputProps = {
  className?: string;
  suffixElement?: React.ReactElement;
  prefixElement?: React.ReactElement;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, suffixElement, prefixElement, ...rest }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <div className="flex w-full items-center gap-x-3 bg-interface-neutral-2 px-5 py-3">
        {prefixElement
          ? cloneElement(prefixElement, {
              className: clsx("text-interface-neutral-4", {
                "text-interface-neutral-6": isFocused
              })
            })
          : null}
        <input
          className={clsx(
            className,
            "flex-1 rounded-[4px] bg-inherit text-interface-neutral-6 outline-none placeholder:text-interface-neutral-4"
          )}
          ref={ref}
          onFocus={(event) => {
            setIsFocused(true);
            rest.onFocus?.(event);
          }}
          onBlur={(event) => {
            setIsFocused(false);
            rest.onBlur?.(event);
          }}
          {...rest}
        />
        {suffixElement ? cloneElement(suffixElement) : null}
      </div>
    );
  }
);

Input.displayName = "Input";
